export class Controller {

    /** @ngInject */
    constructor($state, $rootScope, StartLicensePayment, LicenseTierDetails) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.StartLicensePayment = StartLicensePayment;
        this.LicenseTierDetails = LicenseTierDetails;
    }

    $onInit() {
        this.licenseInfo = this.licenseDetails.licenseInfo;
        this.selectedTier = this.licenseTiers[0];
        this.selectedPrice = this.selectedTier.prices[0];
        this.seats = 10;

        if(this.licenseInfo.licenseStatus == 'LICENSED') {
            this.$state.go('company.license-management.current-plan');
        }
    }

    viewDetails() {
        this.LicenseTierDetails(this.licenseTiers);
    }

    selectedTierChanged() {
        this.selectedPrice = this.selectedTier.prices[0];
    }

    processBillingInterval(interval) {
        if(interval == 1) {
            return 'Monthly'
        } else if(interval == 12) {
            return '1 Year'
        } else if(interval == 24) {
            return '2 Years'
        } else if(interval == 36) {
            return '3 Years'
        }
    }
    
    getTotalPriceValue() {
        if(this.selectedTier && this.selectedPrice && this.seats > 0) {
            return this.selectedPrice.price * this.seats + ' ' + this.selectedPrice.currency; 
        } else {
            return 'NaN'
        }
    }

    startSubscription() {
        this.StartLicensePayment(this.selectedTier, this.selectedPrice, this.seats, this.email, this.getTotalPriceValue())
        .then(sessionUrl => {
            if(sessionUrl) {
                this.$state.go('company.license-management.current-plan', {}, {reload: '^'});
            }
        })
    }

    subscribeButtonDisabled() {
        return !(this.selectedTier && this.selectedPrice && this.seats > 0 && this.$rootScope.emailPattern.test(this.email));
    }

}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/purchase-license/purchase-license.controller.js